export const auth = {
  _root: "/auth",
  login: "/login"
};
